// Utilities
import MobileBreakpointControl from 'Mixins/MobileBreakpointControl'
// Components
import AppLinkIcon from 'Ui/AppLinkIcon'
import TheSidebarMenuLayout from '../components/TheSidebarMenuLayout'

export default {
  components: {
    AppLinkIcon,
    TheSidebarMenuLayout,
  },

  mixins: [MobileBreakpointControl],

  computed: {
    borderTopClass() {
      return (link) => {
        return !this.isMobile && link.border && 'border-top'
      }
    },
  },
}
